// src/context/DesignSystemContext.jsx
import { createContext, useContext } from 'react';

export const DesignSystemContext = createContext(null);

export const useDesignSystem = () => useContext(DesignSystemContext);
